let cache = null
export const setHistory = history => { cache = history }
export const getHistory = () => cache